function Contact() {
  return (
    <div>
      <h1>Contact Us</h1>
      <p>Email: info@cybersentinel.com</p>
    </div>
  );
}

export default Contact;